import { createContext } from "react";

import { IColumnContext } from "./column-context.types";

export const defaultContext: IColumnContext = { isBody: true };

const ColumnContext = createContext<IColumnContext>(defaultContext);
export default ColumnContext;
